import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';
import { ProductGroup } from '../../../models/product-group.model';

import * as productGroupActions from '../actions/product-groups.actions';
import { ActionType } from '../actions/product-groups.actions';


export interface State extends EntityState<ProductGroup> { fetchRunning: null; addProductGroupStatus: { status: null, id: null }; }

export const productGroupAdapter: EntityAdapter<ProductGroup> = createEntityAdapter<ProductGroup>();

export const initialState: State = productGroupAdapter.getInitialState({ fetchRunning: null, addProductGroupStatus: { status: null, id: null } });

export function productGroupReducer(
  state: State = initialState,
  action: productGroupActions.ProductGroupActions
) {
  switch (action.type) {

    case ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYIDSITEID_SUCCESS:
      return productGroupAdapter.setAll(action.productGroups, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYID_SUCCESS:
      return productGroupAdapter.setAll(action.productGroups, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_PRODUCTGROUPS_SUCCESS:
      return productGroupAdapter.setAll(action.productGroups, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.ADD_PRODUCTGROUP:
      return {
        ...state,
        fetchRunning: true,
        addProductGroupStatus: { status: false, ids: null }
      };
    case ActionType.ADD_PRODUCTGROUP_SUCCESS:
      return productGroupAdapter.addOne(action.productGroup, {
        ...state,
        fetchRunning: false,
        addProductGroupStatus: { status: true, id: action.productGroup.id }
      });

    case ActionType.ADD_PRODUCTGROUP_FAILED:
      return {
        ...state,
        fetchRunning: false,
        addProductGroupStatus: { status: false, id: null }
      };

    case ActionType.DELETE_PRODUCTGROUP:
      return {
        ...state,
        fetchRunning: true,
      };
    // case ActionType.DELETE_PRODUCTGROUP_SUCCESS:
    //   return productGroupAdapter.removeOne(action.id, {
    //     ...state,
    //     fetchRunning: false,
    //   });

    case ActionType.DELETE_PRODUCTGROUP_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };
    case ActionType.UPDATE_PRODUCTGROUP:
      return {
        ...state,
        fetchRunning: true,
      };
    case ActionType.UPDATE_PRODUCTGROUP_SUCCESS:
      return {
        ...state,
        fetchRunning: false,
      };
    case ActionType.UPDATE_PRODUCTGROUP_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };



    //  return productGroupAdapter.addOne(action.payload.productGroup, state);
    // case productGroupActions.TOGGLE_DONE:
    //   return productGroupAdapter.updateOne(
    //     { id: action.payload.id, changes: { done: action.payload.done } },
    //     state
    //   );
    // case productGroupActions.UPDATE_PRODUCTGROUP:
    //   return productGroupAdapter.updateOne(
    //     { id: action.payload.id, changes: { value: action.payload.newValue } },
    //     state
    //   );
    // case productGroupActions.DELETE_PRODUCTGROUP:
    // return productGroupAdapter.removeOne(action.payload.id, state);



    default:
      return state;
  }
}

export const getFetchRunning = (state: State) => state.fetchRunning;
export const getProductGroupStatus = (state: State) => state.addProductGroupStatus;
